import React, { Component } from 'react';

import withStyles from '@material-ui/core/styles/withStyles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography'
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import PropTypes from 'prop-types';
import MyButton from '../../util/myButton';
import DeleteSoundOff from './DeleteSoundOff';
import SoundOffDialog from './SoundOffDialog';
import LikeButton from './LikeButton';

//icons
import ChatIcon from '@material-ui/icons/Chat';


//redux
import { connect } from 'react-redux';


const Link = require('react-router-dom').Link;


const styles = (theme) => ({
    ...theme.spread,
    card: {
        position: 'relative',
        display: 'flex',
        marginBottom: 20
    },
    image: {
        minWidth: 200
    },
    content: {
        padding: 25,
        objectFit: 'cover'
    }
});

export class SoundOff extends Component {




    render(props) {

        dayjs.extend(relativeTime);
        const { classes, soundOff: { userImg, body, createdAt, userHandle, soundOffId, likeCount, commentCount }, user: { authenticated, credentials: { handle } } } = this.props;

        const deleteButton = authenticated && userHandle === handle ? (

            <DeleteSoundOff soundOffId={soundOffId} />
        ) : null;

        return (
            <Card className={classes.card}>
                <CardMedia title='Profile Image' className={classes.image} image={userImg} />
                <CardContent className={classes.content}>
                    <Typography variant='h5' component={Link} to={`/users/${userHandle}`} >{userHandle}</Typography>
                    {deleteButton}
                    <Typography variant='body2' color='textSecondary' >{dayjs(createdAt).fromNow()}</Typography>
                    <Typography variant='body1' >{body}</Typography>
                    <LikeButton soundOffId={soundOffId} soundOff={this.props.soundOff} />
                    <span>{likeCount} Likes</span>
                    <MyButton tip='Comments'>
                        <ChatIcon color='primary ' />
                    </MyButton>
                    <span>{commentCount} Comments</span>
                    <SoundOffDialog soundOffId={soundOffId} userHandle={userHandle} openDialog={this.props.openDialog} />
                </CardContent>
            </Card>
        )
    }
}


SoundOff.propTypes = {
    user: PropTypes.object.isRequired,
    soundOff: PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired,
    openDialog: PropTypes.bool
};

const mapStateToProps = (state) => ({
    user: state.user
})



export default connect(mapStateToProps)(withStyles(styles)(SoundOff));
